import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { resetConfigurationCode, resetError } from '../../../../Reducers/Configuration/Actions';
import { withStyles } from '@material-ui/core/styles';
import { setVisible } from '../../../../Reducers/Ui/Actions';

import saveIcon from './icons/save.svg';

const SaveButton = withStyles({
  root: {
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '0 8px',
  },
  icon: {
    width: 32,
  },
  label: {
    fontSize: '0.9em',
  },
})(({ classes }) => {
  const { error } = useSelector((state) => state.Configuration);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleSave = async () => {
    if (error) {
      dispatch(resetError());
    }
    await dispatch(resetConfigurationCode());
    dispatch(setVisible('saveConfiguration', true));
  };
  return (
    <div className={classes.root} onClick={handleSave} title={t('saveConfiguration.title')}>
      <img src={saveIcon} className={classes.icon} />
    </div>
  );
});

export default SaveButton;
